// Models
import { UserModel } from '../../../shared/models';

export namespace UserAuthActions {
	export class SetUser {
		constructor(public user: UserModel) {}
		static readonly type = '[UserAuth] Set User';
	}

	export class UpdateUser {
		constructor(public user: UserModel) {}
		static readonly type = '[UserAuth] Update User Tenant';
	}

	export class DeleteUser {
		static readonly type = '[UserAuth] Delete User';
	}

	export class ConfirmEula {
		static readonly type = '[UserAuth] Confirm Eula';
	}
}
